import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";

export const RISPOSTE = {
  accettato: { label: "Accettato", cls: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300" },
  rifiutato: { label: "Rifiutato", cls: "bg-rose-100 text-rose-700 dark:bg-rose-500/15 dark:text-rose-300" },
  forse: { label: "Forse", cls: "bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-300" },
};

export function RispostaBadge({ risposta, tid }) {
  const r = RISPOSTE[risposta];
  return <span data-testid={tid} className={`text-[10px] font-semibold px-1.5 py-0.5 rounded-full ${r ? r.cls : "bg-slate-100 text-slate-500 dark:bg-slate-800"}`}>{r ? r.label : "In attesa"}</span>;
}

export function useInvitiSync(api, refresh, enabled) {
  const [syncing, setSyncing] = useState(false);
  const sync = useCallback(async (manual = false) => {
    setSyncing(true);
    try {
      const r = await api.syncInviti();
      if (r.aggiornati > 0) await refresh();
      if (manual) toast.success(r.aggiornati > 0 ? `${r.aggiornati} risposte aggiornate` : "Nessuna nuova risposta");
    } catch (e) {
      if (manual) toast.error(e?.response?.data?.detail || "Lettura risposte non riuscita");
    } finally {
      setSyncing(false);
    }
  }, [api, refresh]);
  useEffect(() => { if (enabled) sync(false); }, [enabled]); // eslint-disable-line react-hooks/exhaustive-deps
  return { sync, syncing };
}
